// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAtYPKwgMyjjkZarhM2VX_7uvbmIjvo9O4",
    authDomain: "savanawebsite-870ab.firebaseapp.com",
    projectId: "savanawebsite-870ab",
    storageBucket: "savanawebsite-870ab.firebasestorage.app",
    messagingSenderId: "350743771757",
    appId: "1:350743771757:web:671cd3a39c0d4177499d64",
    measurementId: "G-RRK1RXCRWG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export default app;